import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-unit-direction",
  "use": "fi-icon-custom-unit-direction-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"fi-icon-custom-unit-direction\">\n  <defs>\n    <style>\n      #fi-icon-custom-unit-direction .cls-4 {\n        fill: #fff;\n      }\n    </style>\n  </defs>\n  <path id=\"fi-icon-custom-unit-direction_Path_3898\" data-name=\"Path 3898\" class=\"cls-4\" d=\"m37.32,36.1l-7.28-1.91-7.57,1.63,7.5-19.09,7.35,19.37Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol